import { lazy } from 'react';

import { productsTranslations as enProducts } from '@/lang/en/products';
import { productsTranslations as esProducts } from '@/lang/es/products';
import { productsTranslations as ptProducts } from '@/lang/pt/products';
import { label, type FeatureModule } from '@/platform/app/contracts';
import { namespaceBundle } from '@/platform/i18n/types';

import { productSlice } from './domain/state/productSlice';

const ProductsNavigation = lazy(() =>
  import('./ProductsNavigation').then((m) => ({ default: m.ProductsNavigation })),
);

/** Product catalog used by the e-commerce agent. */
export const productsModule: FeatureModule = {
  id: 'products',
  routes: [{ path: 'products/*', to: '/app/products', Component: ProductsNavigation }],
  nav: [
    {
      sectionId: 'main',
      order: 20,
      to: '/app/products',
      label: label('global', 'sidebar_products_label'),
    },
  ],
  slices: [productSlice],
  i18n: namespaceBundle('products', { es: esProducts, en: enProducts, pt: ptProducts }),
};
